import App from './App';



const items = [];
const $el = $('#dn-sokuhou-seikaihaiten-app');
const $headers = $el.find('thead th');
const $bodies = $el.find('tbody td');

$headers.each(function() {
  const $header = $(this);
  items.push({html: $header.html(), status: $header.attr('data-status')});
});
$bodies.each(function(index) {
  const item = items[index];
  const $body = $(this);
  const $links = $body.children();
  item.links = [];
  $links.each(function() {
    const $link = $(this);
    const html = $link.html();
    item.links.push({
      type: html.trim().toLowerCase(),
      html: html,
      href: $link.attr('href'),
      linkset: $link.attr('data-linkset'),
    });
  });
});

const $vm = new Vue({
  el: $el.get(0),
  parent: window.dn,
  render: h => h(Object.assign({}, App, {
    data() {
      return {items}
    },
  })),
});



// WEBPACK FOOTER //
// ./src/js/jikosaiten/seikaihaiten/index.js